import type { CustomerActiveRewardsEntity } from "@apps/rewards/modules/CustomerRewards/models/RewardsCustomerRewardsEntities";

import type {
    CustomerActiveRewardsRewardDTO,
    CustomerActiveRewardsSdkResultDTO,
} from "../../types";

const mapRewardToDTO = (
    reward: CustomerActiveRewardsEntity["reward"]
): CustomerActiveRewardsRewardDTO => {
    switch (reward.type) {
        case "discount": {
            return {
                type: "discount",
                discountValue: reward.discountValue,
                discountCode: reward.discountCode,
            };
        }
        case "gift_card": {
            return {
                type: "gift_card",
                initialValue: reward.initialValue,
                balance: reward.balance,
                code: reward.code,
            };
        }
        case "free_product": {
            return {
                type: reward.type,
                discountValue: reward.discountValue,
                discountCode: reward.discountCode,
                productHandle: reward.productHandle,
                productTitle: reward.productTitle,
                productImage: reward.productImage,
                productId: reward.productId,
                variantId: reward.variantId,
                variantTitle: reward.variantTitle,
                variantImage: reward.variantImage,
            };
        }
        default:
            throw new Error("Unknown type");
    }
};

export const mapCustomerActiveRewardsToDTO = (
    items: Array<CustomerActiveRewardsEntity>
): Array<CustomerActiveRewardsSdkResultDTO> =>
    items.map((item) => ({
        id: item.id,
        type: item.type,
        reward: mapRewardToDTO(item.reward),
    }));
